<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card v-if="!loading.data" flat>
            <v-card-title>
                {{$t('users_title')}}
                <v-spacer></v-spacer>
                <v-btn
                    class="mx-1"
                    v-if="selected.user.length == 1 && authorizations.users.read"
                    @click="openUserDisplayDialog({ id: selected.user[0].id})"
                    icon
                    >
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn 
                    class="mx-1"
                    @click="refreshDataFetch"
                    icon>
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        :label="$t('search')"
                        solo
                        v-model="search"
                        @keypress.enter="createdDataFetch"
                        hide-details>
                    </v-text-field>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            :disabled="!authorizations.users.create"
                            @click="openUserDialog({editMode: false})"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="!authorizations.users.create">mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_user') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider v-if="selected.user.length"></v-divider>
                        <v-list-item
            
                            @click="openUserDisplayDialog({ id: selected.user[0].id})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('show_user') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.user.length == 1 "
                            :disabled="!selected.user[0].meta.editable"
                            @click="openUserDialog({editMode: true, id: selected.user[0].id})"
                            link
                            >
                            <v-list-item-icon>
                                <v-icon :disabled="!selected.user[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_user') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.user.length && authorizations.users.delete"
                            :disabled="!selected.user[0].meta.deletable"
                            @click="openDeleteSingleDialog({target: 'users', id: selected.user[0].id})"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="!selected.user[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_user') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <v-text-field
                    label="Search"
                    v-model="search"></v-text-field>
                <v-data-table
                    :headers="headers.user"
                    v-model="selected.user"
                    dense
                    :items="users.data"
                    :search="search"
                    show-select
                    single-select>
                    <template v-slot:[`item.inactive`]="{ item }">
                        <v-icon :color="item.inactive ? 'error' : 'success'">
                            {{ item.inactive ? 'mdi-account-cancel' : 'mdi-account-check'  }}
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <UserDialog
            @submit="createdDataFetch"
            ref="userDialog"/>
        <UserDisplayDialog
            ref="userDisplayDialog"/>
        <DeleteSingleDialog
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import UserDisplayDialog from '@/components/administration/UserDisplayDialog';
import DeleteSingleDialog from '@/components/common/DeleteSingleDialog';
import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog';
import UserDialog from '@/components/administration/UserDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: 'Users',
    components: {
        RetryDialog,
        UserDialog,
        UserDisplayDialog,
        DeleteSingleDialog,
        AlertDialog
    },
    data() {
        return {
            loading: {
                data: false
            },
            headers: {
                user: [
                    { text: this.$t('name'), value: "name"  },
                    { text: this.$t('username'), value: "username"  },
                    { text: this.$t('last_login'), value: "last_login" },
                    { text: this.$t('active'), value: "inactive"  }
                ]
            },
            selected: {
                user: []
            },
            search: null,
            options: {},            
        }
    },
    computed: {
        ...mapState('administration/user', ["users"]),
        ...mapState('authentication', ["authorizations"])
    },
    methods: {
        ...mapActions('administration/user',["fetchUsers", "removeUser"]),
        async createdDataFetch() {
            try {
                this.loading.data = true ;
                await this.fetchUsers();
                this.loading.data = false;

            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        openUserDialog(params) {
            this.$refs.userDialog.open(params);
            this.selected.user = [];
        },
        openUserDisplayDialog(params) {
            this.$refs.userDisplayDialog.open(params);
            this.selected.user = [];
        },
        openDeleteSingleDialog(params) {
            this.$refs.deleteSingleDialog.open(params);
            this.selected.user = [];
        },
        refreshDataFetch() {
            this.search = null;
            this.createdDataFetch();
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'users') {
                this.removeUser(params)
                    .then(() => {
                        this.$refs.deleteSingleDialog.close();
                        this.createdDataFetch();
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
                else this.close()
            }
        },
      
    },
    created () {
        this.createdDataFetch();
        
    },
}
</script>